import React, { useEffect } from "react";
import Header from "./Header";
import Footer from "../components/Footer";

export default function DueDates({ isAuthenticated, setIsAuthenticated }) {
  // 1) Синхронная проверка токена и JWT-exp
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsAuthenticated(false);
      return;
    }
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp * 1000 < Date.now()) throw new Error("expired");
    } catch {
      localStorage.removeItem("token");
      setIsAuthenticated(false);
      return;
    }
    // 2) Серверная валидация
    fetch("/api/users-logic/me/", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => {
        if (!res.ok) {
          localStorage.removeItem("token");
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      })
      .catch(() => {});
  }, [setIsAuthenticated]);

  const months = [
    "July", "August", "September", "October", "November", "December",
    "January", "February", "March", "April", "May", "June"
  ];
  const dueDates = [
    "August 31", "September 30", "October 31", "November 30", "December 31", "January 31",
    "Last day of February", "March 31", "April 30", "May 31", "June 30", "July 31"
  ];

  return (
    <div className="bg-white text-[#0F2C5E] flex flex-col min-h-screen font-sans">
      <Header isAuthenticated={isAuthenticated} />
      <main className="flex-grow px-4 py-14">
        <h2 className="text-xl sm:text-2xl font-bold mb-8 uppercase tracking-wide text-center">
          Form 2290 Due Dates
        </h2>
        <div className="overflow-x-auto">
          <table className="mx-auto w-full max-w-3xl text-sm">
            <thead className="bg-[#0F2C5E] text-white">
              <tr>
                <th className="p-2">Month Vehicle First Used</th>
                <th className="p-2">Due Date</th>
              </tr>
            </thead>
            <tbody>
              {months.map((month, i) => (
                <tr key={i} className={i % 2 === 0 ? "even:bg-white" : "odd:bg-gray-100"}>
                  <td className="p-2">{month}</td>
                  <td className="p-2">{dueDates[i]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p className="mt-6 text-xs text-gray-500 max-w-xl mx-auto">
          Filing late? Avoid penalties by submitting Form 2290 before the deadline.
        </p>
      </main>
      <Footer />
    </div>
  );
}
